import { render } from "./DSGVOBanner.vue?vue&type=template&id=6c06fca4&scoped=true"
import script from "./DSGVOBanner.vue?vue&type=script&lang=js"
export * from "./DSGVOBanner.vue?vue&type=script&lang=js"

import "./DSGVOBanner.vue?vue&type=style&index=0&id=6c06fca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c06fca4"]])

export default __exports__